module.exports = __webpack_public_path__ + "static/media/Folder.fce93cc6.svg";